import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | LeadLoop`;
  }, [title]);
};

export { useDocumentTitle };
